export default __webpack_public_path__ + "static/media/6806-obolazul.0e41bd4b.pdf";